import { takeEvery, call, put, select } from 'redux-saga/effects'
import { buildGETUrl } from '../../../utilities/buildGETUrl'
import { EDIT_VIDEOLIST, loading } from '../../../store/Modal/types/VideolistCreate/actions'
import { closeModal } from '../../../store/Modal/actions'
import { loadVideolists, setCurrentVideolist, updateVideolist } from '../../../store/ContentVideolists/actions'
import { showAlertError } from '../../../store/Alert/actions'
import axios from 'axios'
import { updateItem } from '../../../store/ContentAllVideolists/actions'

export default function* () {
    yield takeEvery(EDIT_VIDEOLIST, worker)
}

function* worker({ payload }) {
    yield put(loading(true))
    try {
        const created = yield call(fetchEdit, payload)

        if (created.error) {
            yield put(showAlertError({
                errors: [`Ошибка сервера при ${EDIT_VIDEOLIST}.`, created],
                text: "Видеолист не был создан. Попробуйте повторить."
            }))
            yield put(closeModal("videolistEdit"))

        } else {

            yield put(closeModal("videolistEdit"))
            yield put(loadVideolists())
            yield put(updateItem(created.success?.[0]))
            const videolist = yield select(state => state.videolists.currentVideolist)
            yield put(setCurrentVideolist({ videolist: { ...videolist, ...created.success?.[0] } }))
        }
    }
    catch (e) {
        yield put(showAlertError({
            errors: [`Ошибка сети при ${EDIT_VIDEOLIST}.`, e],
            text: "Видеолист не был создан. Попробуйте повторить."
        }))
    }
    finally {
        yield put(loading(false))
        yield put(closeModal("videolistEdit"))
    }
}

function fetchEdit(videolistData) {
    let formData = new FormData()
    let clear = { ...videolistData }
    delete clear.id_videolist
    if (clear && clear.name) {
        Object.keys(clear).forEach(name => {
            formData.set(name, clear[name])
        })
    }

    return axios(
        {
            url: `/videolist/update?id=${videolistData.id_videolist}`,
            method: "POST",
            data: formData
        }
    )
        .then(response => response.data)
}
